{
  "DisplayAsLabel": "Darstellen als:",
  "ColorTileBackgroundLabel": "Fliesenfarbe:",
  "ColorTileTextLabel": "Textfarbe:",
  "FitImageLabel": "Bild anpassen",
  "DisplayTitleLabel": "Titeltextbereich anzeigen",
  "AutoValuePlaceholder": "[Auto]",
  "ImageUrlPlaceholder": "https:\/\/example.com\/image.png",
  "ImageUrlLabel": "Bild URL:",
  "Black": "Schwarz",
  "White": "Weiß",
  "Blanc": "Weiß",
  "Smoke": "Rauch",
  "Grey": "Grau",
  "Battleship": "Schlachtschiff",
  "Aqua": "Aqua",
  "Blue": "Blau",
  "Waters": "Gewässer",
  "Sky": "Himmel",
  "Akixi": "Akixi",
  "Midnight": "Mitternacht",
  "Pistachio": "Pistazie",
  "Green": "Grün",
  "Forest": "Wald",
  "Salmon": "Lachs",
  "Red": "Rot",
  "Rosita": "Rosita",
  "Peach": "Pfirsich",
  "Orange": "Orange",
  "Clementine": "Clementine",
  "Amarelo": "Amarelo",
  "Yellow": "Gelb",
  "Sunflower": "Sonnenblume",
  "Lilac": "Lila",
  "Purple": "Violett",
  "Regal": "Regal",
  "Blush": "Erröten",
  "Pink": "Rosa",
  "Fuchsia": "Fuchsie",
  "Caribbean": "Karibik",
  "Teal": "Blaugrün",
  "Peacock": "Pfau",
  "SimpleTextValue": "[Einfacher Textwert]",
  "ProgressRing": "Fortschrittsring",
  "GradatedDial": "Abgestuftes Zifferblatt",
  "GlideSlope": "Gleitweg",
  "Bullseye": "Volltreffer",
  "BarGauge": "Balkenanzeige",
  "ConeGauge": "Kegellehre",
  "DashboardSpeedometerBlack": "Armaturenbrett-Tachometer (Schwarz)",
  "DashboardSpeedometerAmber": "Armaturenbrett-Tachometer (gelb)",
  "DashboardTemperatureGauge": "Armaturenbrett-Temperaturanzeige",
  "DashboardFuelGauge": "Kraftstoffanzeige im Armaturenbrett",
  "DashboardPowerGauge": "Dashboard-Leistungsanzeige",
  "DashboardColourGauge": "Dashboard-Farbanzeige",
  "GaugeFaceLabel": "Umgekehrte Messfläche:",
  "GaugeFaceDirection": "Spurrichtung umkehren:",
  "MaxScaleLabel": "Maximaler Maßstab:",
  "DisplayPreviewCaption": "Vorschau:",
  "DisplaySettings_SectionHeader": "Bildschirmeinstellungen",
  "NAME": "DisplaySettings",
  "VividSky": "Lebendiger Himmel",
  "ElectricIndigo": "Elektrisches Indigo",
  "OxfordBlue": "Oxford Blau",
  "Aquamarine": "Aquamarin"
}